<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="link"
            actionFild
            @selectRow="show"
            @show="show"
            @nextEstagio="nextEstagio"
            @arquivar="arquivar"
			sorting
            ref="datatable">
		</bsh-datatable>
	</div>
</template>

<script>
export default {
    props: ['link'],
	data(){
		return {
            columns: [
                {
                    label: '#',
                    field: 'id',
                    sort: 'asc'
                },
                {
                    label: 'Cliente',
                    field: 'cliente',
                    order: 'clientes.nome',
                    sort: 'asc'
                },
                {
                    label: 'Estágio',
                    field: 'estagio_badge',
                    order: 'estagios.nome',
                    sort: 'asc'
                },
                {
                    label: 'Tags',
                    field: 'tag_main',
                    noSorting: true
                },
                {
                    label: 'Progresso',
                    field: 'progress_bar',
                    noSorting: true
                },
                {
                    label: 'Data',
                    field: 'data_br',
                    order: 'pedidos.data',
                    sort: 'asc'
                },
                {
                    label: 'Prazo',
                    field: 'prazo_badge',
                    order: 'pedidos.prazo',
                    sort: 'asc'
                },
                {
                    label: 'Itens',
                    field: 'total_itens',
                    sort: 'asc'
                },
                {
                    label: 'Pago',
                    field: 'valor_pago_br',
                    order: 'pedidos.valor_pago',
                    sort: 'asc'
                },
                {
                    label: 'Valor',
                    field: 'valor_total_br',
                    order: 'pedidos.valor_total',
                    sort: 'asc'
                }
            ],
            buttons: [
                {
                    action: 'show',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye',
                    title: 'Ver'
                },
                {
                    action: 'nextEstagio',
                    visible: (row) => {
                        const totalItens = Number(row.total_itens);
                        const estagioId = Number(row.estagio_id);
                        const itensFinalizados = Number(row.itens_finalizados);

                        if (totalItens <= 0 || estagioId >= 4) {
                            return false;
                        }

                        if (estagioId === 2) {
                            return itensFinalizados === totalItens;
                        }

                        return true;
                    },
                    classe: (row) => {
                        const estagioId = Number(row.estagio_id);
                        if (estagioId === 1) return 'btn btn-primary';
                        if (estagioId === 2) return 'btn btn-success';
                        if (estagioId === 3) return 'btn btn-success';
                        return 'btn btn-secondary';
                    },
                    iconClass: (row) => {
                        const estagioId = Number(row.estagio_id);
                        if (estagioId === 1) return 'fas fa-wrench';
                        if (estagioId === 2) return 'fas fa-check';
                        if (estagioId === 3) return 'fas fa-car-side';
                        return '';
                    },
                    title: (row) => {
                        const estagioId = Number(row.estagio_id);
                        if (estagioId === 1) return 'Iniciar Produção';
                        if (estagioId === 2) return 'Finalizar';
                        if (estagioId === 3) return 'Entregue';
                        return '';
                    }
                },
                {
                    action: 'arquivar',
                    visible: (row) => {
                        const estagioId = Number(row.estagio_id);
                        const isEntregue = estagioId === 4 || !!row.entregue;
                        const isNotArquivado = !row.arquivado;
                        return isEntregue && isNotArquivado;
                    },
                    classe: 'btn btn-success',
                    iconClass: 'fas fa-save',
                    title: 'Arquivar'
                }
            ]
    	}
	},
    methods: {
        show(dado){
            this.$emit('show', dado.id);
        },
        nextEstagio(row){
            var config = {
                position: 'bottom-right',
            };
            axios.put(this.$url + '/api/adm/pedidos/next-estagio/' + row.id)
                .then(response => {
                    this.$bshMessage.show(response.data.message, response.data.type, config);
                    if (this.$refs.datatable && this.$refs.datatable.getDados) {
                        this.$refs.datatable.getDados();
                    }
                    this.$emit('reload');
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.message) {
                        this.$bshMessage.show(error.response.data.message, 'error');
                    } else {
                        this.$bshMessage.show('Erro ao avançar estágio do pedido.', 'error');
                    }
                });
        },
        arquivar(row){
            var config = {
                position: 'bottom-right',
            };
            axios.put(this.$url + '/api/adm/pedidos/arquivar/' + row.id)
                .then(response => {
                    this.$bshMessage.show(response.data.message, response.data.type, config);
                    if (this.$refs.datatable && this.$refs.datatable.getDados) {
                        this.$refs.datatable.getDados();
                    }
                    this.$emit('reload');
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response.data.message) {
                        this.$bshMessage.show(error.response.data.message, 'error');
                    } else {
                        this.$bshMessage.show('Erro ao arquivar pedido.', 'error');
                    }
                });
        }
    }
}
</script>